import React, { useEffect } from 'react'

const SessionErrorHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Detectar erro 502
    const handleError = () => {
      // Se a página mostra 502 ou timeout de Keycloak
      const hasError502 = document.body.innerText.includes('502') || 
                          window.location.href.includes('prompt=none')

      if (hasError502) {
        console.log('[SessionErrorHandler] Detectado erro 502, limpando sessão...')
        
        // Limpar todos os cookies relacionados ao Keycloak
        document.cookie.split(';').forEach((c) => {
          const cookieName = c.split('=')[0].trim()
          if (cookieName.includes('KEYCLOAK') || 
              cookieName.includes('keycloak') ||
              cookieName === 'JSESSIONID') {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
          }
        })

        // Limpar localStorage
        const keysToRemove = []
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i)
          if (key?.includes('kc_')) {
            keysToRemove.push(key)
          }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key))

        // Redirecionar para página inicial para fazer login novamente
        console.log('[SessionErrorHandler] Redirecionando para login...')
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }
    }

    // Executar verificação ao carregar
    handleError()

    // Também verificar periodicamente a cada 5 segundos se a página está presa em loop
    const interval = setInterval(() => {
      if (document.title.includes('502') || 
          window.location.href.includes('prompt=none')) {
        handleError()
        clearInterval(interval)
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  return <>{children}</>
}

export { SessionErrorHandler }
